'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemMock = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _mockData = require('./mockData');

var _delay = require('./delay');

var _delay2 = _interopRequireDefault(_delay);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemMock = exports.ItemMock = {
    fetchItemsByIds: function fetchItemsByIds(itemIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var items = itemIds.map(function (x) {
                    return (0, _mockData.getTestItem)(x);
                });
                var biddingInfos = [];
                var bidIncrements = [];
                var catalogs = [];
                var sellers = [];

                items.forEach(function (item) {
                    biddingInfos = (0, _union2.default)(biddingInfos, [(0, _mockData.getTestBiddingInfoForItem)(item.itemId)]);
                    bidIncrements = (0, _union2.default)(bidIncrements, [(0, _mockData.getTestBidIncrementForCatalog)(item.catalogId)]);
                    catalogs = (0, _union2.default)(catalogs, [(0, _mockData.getTestCatalog)(item.catalogId)]);
                    sellers = (0, _union2.default)(sellers, [(0, _mockData.getTestSeller)(item.sellerId)]);
                });
                resolve({
                    data: {
                        biddingInfos: biddingInfos,
                        bidIncrements: bidIncrements,
                        catalogs: catalogs,
                        items: items,
                        sellers: sellers
                    }
                });
            }, _delay2.default);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/item.js
// module id = Agmk
// module chunks = 57